import '@skyscanner-internal/backpack-web/bpk-stylesheets/index.js';

import { createElement } from 'react';

import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import App from './App.jsx';

const router = createBrowserRouter([
  {
    path: '*',
    element: createElement(App),
  },
]);

const root = createRoot(document.getElementById('root'));
root.render(createElement(RouterProvider, { router }));
